module.exports = __webpack_public_path__ + "img/SES_220112010.ff0db66f.jpg";